import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';
import CardThumbnail from '../../shared/CardThumbnail/CardThumbnail';
import CoinsImage from '../../../assets/images/coins-alert.webp';
import ContactIcon from '../../shared/Icons/ContactIcon';
import PosCardIcon from '../../shared/Icons/PosCardIcon';
import ExternalLinkIcon from '../../shared/Icons/ExternalLinkIcon';

export class SenderReceiverProvider {
  static getSenderIcon(type, params) {
    switch (type) {
      case EnterAmountType.P2P: {
        return (
          <CardThumbnail
            organization={params?.organizationCode}
            size={CardThumbnail.Size.SMALL}
          />
        );
      }
      case EnterAmountType.MICROLOAN: {
        return <img src={CoinsImage} width={40} height={40} />;
      }
      case EnterAmountType.MICROLOAN_PAYMENT: {
        return (
          <CardThumbnail
            organization={params?.organizationCode}
            size={CardThumbnail.Size.SMALL}
          />
        );
      }
      case EnterAmountType.POS: {
        return <PosCardIcon />;
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        return <PosCardIcon />;
      }
    }
  }

  static getReceiverIcon(type, params) {
    switch (type) {
      case EnterAmountType.P2P: {
        return <ContactIcon />;
      }

      case EnterAmountType.MICROLOAN: {
        return (
          <CardThumbnail
            organization={params?.organizationCode}
            size={CardThumbnail.Size.SMALL}
          />
        );
      }

      case EnterAmountType.MICROLOAN_PAYMENT: {
        return null;
      }
      case EnterAmountType.POS: {
        return <ContactIcon />;
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        return <ExternalLinkIcon />;
      }
    }
  }
}
